import React from 'react';
import ManageReservations from './ManageReservations';

const ManageReservationsAndInvoices = () => (
  <div className="pb-8">
    <ManageReservations />
  </div>
);

export default ManageReservationsAndInvoices;
